module.exports = __webpack_public_path__ + "static/media/exclamation_gray.3c151294.svg";